/* eslint-disable import/prefer-default-export */
export const LOAD_ALL_BUCKET_DETAILS = 'LOAD_ALL_BUCKET_DETAILS';
export const LOAD_BUCKET_FILES = 'LOAD_BUCKET_FILES';
export const RESET_IMPORT_ASSETS = 'LOAD_DESTINATION_DETAILS';
export const LOAD_PROJECT_DETAILS = 'LOAD_PROJECT_DETAILS';
export const LOAD_PROJECT_BREADCRUMBS = 'LOAD_PROJECT_BREADCRUMBS';
